<div class="bonus-setting">
  <form
    #form="ngForm"
    (ngSubmit)="onSubmitSetting()"
  >
    <div class="row no-gutters mb-20">
      <div class="col-md-2 col-12 text-white fs-18 font-bold">
        Bonus On Deposit
      </div>
      <div class="col-md-10 col-12">
        <div class="mb-5">
          <div class="label fs-16"></div>
          <span class="me-1">OFF</span>
          <mat-slide-toggle
            class="red text-green"
            [checked]="data?.deposit?.mode == 1"
            (change)="data.deposit.mode = $event.checked ? 1 : 0"
          >ON
          </mat-slide-toggle
          >
        </div>
        <ng-container *ngIf="data?.deposit?.mode === 1">
          <div class="d-flex align-items-center mb-3">
            <div class="label fs-16">Date</div>
            <div class="row">
              <div class="col-12">
                <div class="d-inline-block pos-relative">
                  <span class="text">Start Time</span>
                  <p-calendar
                    appendTo="body"
                    name="depositStart"
                    [placeholder]="'dd/mm/yyyy HH:mm'"
                    [dateFormat]="'dd/mm/yy'"
                    [timeOnly]="false"
                    [showIcon]="true"
                    [showTime]="true"
                    inputStyleClass="form-control"
                    [(ngModel)]="data.deposit.start_time"
                  ></p-calendar>
                </div>
                <div class="calender-spacing-box"></div>
                <div class="d-inline-block pos-relative">
                  <span class="text">End Time</span>
                  <p-calendar
                    name="depositEnd"
                    [placeholder]="'dd/mm/yyyy HH:mm'"
                    [dateFormat]="'dd/mm/yy'"
                    [timeOnly]="false"
                    [showIcon]="true"
                    [showTime]="true"
                    inputStyleClass="form-control"
                    [(ngModel)]="data.deposit.end_time"
                  ></p-calendar>
                  <div class="calender-spacing-box"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-4">
            <div class="label fs-16 m-auto" style="vertical-align: top">
              Amount Conditions
            </div>
            <div class="d-inline-block" style="width: calc(100% - 180px)">
              <div
                class="row"
                *ngFor="let con of data.deposit.conditions; let i = index"
              >
                <div class="col-12">
                  <div class="text-label m-auto">Condition {{ i + 1 }}</div>
                </div>
                <div class="col-12">
                  <input
                    class="extent"
                    type="number"
                    name="deposit_threshold{{ i }}"
                    [(ngModel)]="con.threshold"
                  />
                  <span class="m-1">JPY</span>
                  <input
                    class="extent disabled"
                    type="number"
                    name="view_threshold{{ i }}"
                    disabled
                    [value]="viewBonus?.conditions[i]?.threshold"
                  />
                  <span class="m-1">USD</span>

                  <input
                    class="extent ms-3"
                    type="number"
                    [(ngModel)]="con.rate"
                    name="deposit_rate{{ i }}"
                  />
                  <span class="ml-1">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-3 pt-2">
            <div class="label fs-16">Upper Limit</div>
            <input
              class="extent"
              type="number"
              name="depositUpLimit"
              [(ngModel)]="data.deposit.up_limit"
            />
            <span class="m-1">JPY</span>
            <input
              type="number"
              name="depositUpLimitUSD"
              class="extent"
              placeholder="ex:10"
              [disabled]="true"
              [(ngModel)]="viewBonus.up_limit_usd"
              required
            />
            <span class="ml-1">USD</span>

            <div style="margin-left: 20px;" class="d-inline-block pos-relative">
              <span class="text">Start Time</span>
              <p-calendar
                name="up_limit_start_time"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [timeOnly]="false"
                [showIcon]="true"
                [showTime]="true"
                inputStyleClass="form-control"
                required
                [(ngModel)]="data.deposit.up_limit_start_time"
              ></p-calendar>
              <div class="calender-spacing-box"></div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-3">
            <div class="label fs-16">Bonus Timeout</div>
            <!--<mat-form-field appearance="standard" size="small">
              <mat-label>Timeout</mat-label>
              <mat-select [(ngModel)]="data.deposit.dfw">
                <mat-option *ngFor="let v of bonusTimeout" [value]="v">{{v}}</mat-option>
              </mat-select>
            </mat-form-field>-->
            <select name="dfw" [(ngModel)]="data.deposit.dfw" required>
              <option [ngValue]="item" *ngFor="let item of dfws">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="d-flex align-items-center mb-3">
            <div class="label fs-16">Multiple</div>
            <span class="me-1">OFF</span>
            <mat-slide-toggle
              class="red text-green"
              [checked]="data.deposit.multiple_time"
              (change)="data.deposit.multiple_time = $event.checked"
            >ON
            </mat-slide-toggle
            >
          </div>
          <div class="d-flex align-items-center mb-3">
            <div class="label fs-16">Bonus Type</div>
           <!-- <mat-form-field appearance="standard" size="small">
              <mat-label>Type</mat-label>
              <mat-select [(value)]="data.deposit.bonus_type">
                <mat-option [value]="0">Normal</mat-option>
                <mat-option [value]="1">Before</mat-option>
                <mat-option [value]="2">After</mat-option>
              </mat-select>
            </mat-form-field>-->
            <select name="bonusType" [(ngModel)]="data.deposit.bonus_type">
              <option [ngValue]="0">Normal</option>
              <option [ngValue]="1">Before</option>
              <option [ngValue]="2">After</option>
            </select>
          </div>
          <div class="d-flex align-items-center mb-3">
            <div class="label fs-16">Comment</div>
            <input
              class="extent"
              style="width: 250px;"
              name="deposit_comment"
              maxlength="31"
              pattern="^[0-9a-zA-Z]+$"
              required
              [(ngModel)]="data.deposit.comment"
            />
          </div>
        </ng-container>
      </div>
    </div>
    <hr/>
    <div class="row no-gutters mb-20">
      <div class="col-md-2 col-12 text-white fs-18 font-bold">
        Bonus On Open Account
      </div>
      <div class="col-md-10 col-12">
        <div class="mb-3">
          <div class="label fs-16"></div>
          <span class="me-1">OFF</span>
          <mat-slide-toggle
            class="red text-green"
            [checked]="data?.open_account?.mode === 1"
            (change)="data.open_account.mode = $event.checked ? 1 : 0"
          >ON</mat-slide-toggle>
        </div>
        <ng-container *ngIf="data?.open_account?.mode === 1">
          <div class="mb-3 pt-2">
            <div class="label fs-16">Apply to IB Account</div>
            <span class="me-1">OFF</span>
            <mat-slide-toggle
              class="red text-green"
              [checked]="data?.open_account?.mode === 1"
              (change)="data.open_account.mode = $event.checked ? 1 : 0"
            >ON</mat-slide-toggle>
          </div>
          <div class="mb-3 mt-4" >
            <div class="label fs-16">Amount</div>
            <div class="d-inline-block pos-relative">
              <input
                class="extent"
                type="number"
                name="openAccountJPY"
                [(ngModel)]="data.open_account.jpy_bonus"
              />
              <span class="m-1">JPY</span>
              <input
                class="extent"
                type="number"
                name="openAccountUSD"
                [(ngModel)]="data.open_account.usd_bonus"
              />
              <span class="ml-1">USD</span>
            </div>
          </div>
          <div class="mb-3 mt-4 pt-2">
            <div class="label fs-16">Date</div>
            <div class="d-inline-block pos-relative">
              <span class="text">Start Time</span>
              <p-calendar
                name="accountStart"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [showTime]="true"
                inputStyleClass="form-control"
                [(ngModel)]="data.open_account.start_time"
              ></p-calendar>
              <div class="calender-spacing-box"></div>
            </div>
            <div class="d-inline-block pos-relative">
              <span class="text">End Time</span>
              <p-calendar
                name="accountEnd"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [showTime]="true"
                inputStyleClass="form-control"
                [(ngModel)]="data.open_account.end_time"
              ></p-calendar>
              <div class="calender-spacing-box"></div>
            </div>
          </div>
          <div class="mb-3 pt-2">
            <div class="label fs-16">Comment</div>
            <input
              style="width: 250px;"
              class="extent"
              name="open_account_comment"
              maxlength="31"
              pattern="^[0-9a-zA-Z]+$"
              [(ngModel)]="data.open_account.comment"
              required
            />
          </div>
        </ng-container>
      </div>
    </div>
    <hr edit-permission/>
    <div class="row no-gutters">
      <div class="col-md-12 col-xs-12" edit-permission>
        <button mat-button type="submit" class="btn btn-red pull-right btn-bonus-apply">
          Apply
        </button>
      </div>
    </div>
  </form>
</div>
